import React from 'react';
import { WbHeader } from '@digital-engineering-experiences/wb-webcomponents';
import { Link,useLocation } from 'react-router-dom';

const Header: React.FC = () => {

    const location = useLocation();
    const currentPath = location.pathname;

    return (
        <WbHeader sticky={true} logo={<Link to={`${process.env.PUBLIC_URL}`}><img src={`${process.env.PUBLIC_URL}/logo-tilburg.svg`} alt="Tilburg Logo" /></Link>} apptitle="Ketenmodel stedelijk water Tilburg">
            <nav>
                <ul>
                    <li>
                        <Link to="/map" aria-current={currentPath === '/map' ? 'page' : undefined}>Gis viewer</Link>
                    </li>
                    <li>
                        <Link to="/downloads" aria-current={currentPath.indexOf('/downloads') !== -1 ? 'page' : undefined}>Downloads</Link>
                    </li>
                    <li>
                        <Link to="/wiki" aria-current={currentPath.indexOf('/wiki') !== -1 ? 'page' : undefined}>Wiki</Link>
                    </li>
                    <li>
                        <Link to="/modelcijfers" aria-current={currentPath.indexOf('/modelcijfers') !== -1 ? 'page' : undefined}>Model in cijfers</Link>
                    </li>
                </ul>
            </nav>
        </WbHeader>
    );
};

export default Header;